<template>
  <div
    class="w-full bg-accent-yellowGreen border-black border-t-4 lg:sticky top-0 z-50 shadow-lg opacity-95"
  >
    <div class="grid grid-cols-3 gap-2 py-2 px-10 container mx-auto">
      <div class="col-span-3 lg:col-span-1 my-auto flex flex-col gap-2">
        <div>
         <label class="bg-yellow-100 text-black font-bold text-md px-1 py-1 rounded-md ring-2 ring-accent-green-dark transition-transform duration-300 transform scale-105 animate-pulse"
              style="text-shadow: 0 0 8px rgba(250, 204, 21, 0.9);">
          Shipped From:
          </label>
          <Menu as="div" class="relative inline-block text-left">
            <MenuButton
            :disabled="$route.meta.canChangeShip != true"
              class="inline-flex hover:underline text-accent-green-dark disabled:text-gray-500 disabled:no-underline"
            >
              {{ mainStore.region?.cCountry }}
              <ChevronDownIcon class="h-4 my-auto"></ChevronDownIcon>
            </MenuButton>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <MenuItems
                class="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
              >
                <div class="px-1 py-1">
                  <!-- This dropdown changes the state of the store directly -->
                  <MenuItem
                    v-for="company in mainStore.regions"
                    :key="company.cCountry"
                  >
                    <button
                      @click="mainStore.setRegion(company)"
                      class="text-gray-900 hover:bg-accent-green hover:text-white group flex w-full items-center rounded-md px-2 py-2 text-sm"
                    >
                      {{ company.cCountry }}
                    </button>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div>
          Select Company/Brand:
          <Menu as="div" class="relative inline-block text-left">
            <MenuButton
              class="inline-flex hover:underline text-accent-green-dark"
            >
              {{ mainStore.brand?.className }}
              <ChevronDownIcon class="h-4 my-auto"></ChevronDownIcon>
            </MenuButton>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
             <!-- Linzy:20250820 Add a scroll to the brand dropdown (Set max height:max-h-80 Enable vertical scroll if content taller than max-h-80:overflow-y-auto) -->
              <MenuItems
                class="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 max-h-80 overflow-y-auto"
              >
                <div class="px-1 py-1">
                  <!-- This dropdown calls directly to the store -->
                  <MenuItem v-for="brand in mainStore.brandList" :key="brand">
                    <button
                      @click="mainStore.setBrand(brand)"
                      class="text-gray-900 hover:bg-accent-green hover:text-white group flex w-full items-center rounded-md px-2 py-2 text-sm"
                    >
                      {{ brand }}
                    </button>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
      <div class="col-span-3 lg:col-span-1 my-auto flex justify-center">
        <div class="rounded-full bg-accent-green-dark h-10 w-10 flex mx-4">
          <span class="m-auto text-white font-semibold">{{
            mainStore.class?.className.substring(0, 1).toUpperCase()
          }}</span>
        </div>
        <div class="flex flex-col">
          <span>{{ mainStore.class?.className }}</span>
          <span>{{ mainStore.user?.icdCpny }}</span>
        </div>
      </div>
      <div class="col-span-3 lg:col-span-1 m-auto">
        <div class="flex">
          <router-link
            v-if="
              mainStore.user?.icdType == 'MGR' &&
              mainStore.class?.classId.substring(0, 3) == 'MAR'
            "
            :to="{ name: 'Approval' }"
            class="bg-white px-2 py-1 border-accent-green border transition-all hover:bg-accent-gray flex ring-accent-green-dark focus:ring-1"
          >
            Audit Approval
          </router-link>
          <router-link
            :to="mainStore.editMode == false ? { name: 'Cart' } : { name: 'EditOrder' }"
            class="bg-white px-2 py-1 ml-4 border-accent-green border transition-all hover:bg-accent-gray flex ring-accent-green-dark focus:ring-1"
          >
            <ShoppingCartIcon class="h-5 pr-1 mt-[0.1rem]"></ShoppingCartIcon>
            {{mainStore.editMode == false ? "My Cart" : "Edit Order"}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ShoppingCartIcon, ChevronDownIcon } from "@heroicons/vue/outline";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
export default {
  components: {
    ShoppingCartIcon,
    ChevronDownIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },
  data() {
    return {};
  }
};
</script>
